// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"104693bccc8e30404f93","883":"7b7459158496d7e6ccbf"}[chunkId] + ".js";
};